

import React from 'react'
import HeroSection from './TestingPage/HeroSection'
import TestingServices from './TestingPage/TestingServices'
import CodoidAPITesting from './TestingPage/Testingtools'
import ContactForm from './TestingPage/ConactForm'
import WhyChooseUs from './TestingPage/WhyChoose'
import { Helmet } from 'react-helmet';
import Approach from './TestingPage/Approach'
const Testing = () => {


  return (
    <div>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>PTKCS Tech | Software Testing Services – Quality Assurance & Performance Validation</title>
        <meta 
          name="description" 
          content="PTKCS Tech provides comprehensive software testing services, including functional testing, performance validation, automation, and security assessments. We ensure your applications meet the highest quality standards, delivering seamless user experiences and robust performance." 
        />
        <meta 
          name="keywords" 
          content="software testing, quality assurance, performance testing, functional testing, automation testing, security testing, application validation, PTKCS Tech, testing services, QA services" 
        />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="PTKCS Tech | Software Testing Services – Quality Assurance & Performance Validation" />
        <meta 
          property="og:description" 
          content="PTKCS Tech provides comprehensive software testing services, including functional testing, performance validation, automation, and security assessments. We ensure your applications meet the highest quality standards, delivering seamless user experiences and robust performance." 
        />
        <meta property="og:image" content="https://ik.imagekit.io/kqumni8l2/Infographic%20Images/Ln_infographic.png?updatedAt=1758524184149" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="PTKCS Tech | Software Testing Services – Quality Assurance & Performance Validation" />
        <meta 
          name="twitter:description" 
          content="PTKCS Tech provides comprehensive software testing services, including functional testing, performance validation, automation, and security assessments. We ensure your applications meet the highest quality standards, delivering seamless user experiences and robust performance." 
        />
        <meta name="twitter:image" content="https://ik.imagekit.io/kqumni8l2/Infographic%20Images/Ln_infographic.png?updatedAt=1758524184149" />
        
        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="author" content="PTKCS Tech" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>


                <section>
               <HeroSection/>
      </section>
      <section>
        <Approach />
       </section>
      <section>
        <TestingServices/>
      </section>


      <section>
        <CodoidAPITesting />
      </section>

     

      <section>
        <WhyChooseUs/>
      </section>
       <section>
        <ContactForm/>
      </section>
    </div>
  )
}

export default Testing
